import {
  Button,
  createStyles,
  Grid,
  Theme,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import React from "react";
import { MyPATDialog } from "../../../common";

const styles = (theme: Theme) =>
  createStyles({
    txtRight: {
      textAlign: "right",
    },
    primaryBtn: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "19px",
      height: "44px",
      color: "#fff",
      backgroundColor: "#1D7DEA",
      padding: "8px 30px",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#1D7DEA",
      },
    },
    outlineBtn: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "19px",
      height: "44px",
      color: "#1D7DEA",
      backgroundColor: "transparent",
      padding: "8px 30px",
      textTransform: "capitalize",
      border: "none",
      "&:hover": {
        border: "none",
        backgroundColor: "transparent",
      },
    },
    normalTxt: {
      fontSize: "14px",
      fontWeight: "normal",
      lineHeight: "150%",
      color: "#333",
    },
    txtCenter: {
      textAlign: "center",
    },
  });

interface Props extends WithStyles<typeof styles> {
  handleClose: () => void;
  handleViewChallenges: () => void;
}

function ForceSaveForChallengePopup(props: Props) {
  const { classes, handleClose, handleViewChallenges } = props;

  return (
    <MyPATDialog
      dialogOpen={true}
      dialogHasActions={true}
      dialogHeading={"Are you sure ?"}
      isAlignCenter={true}
      customButtonVariant="withoutBorderCloseIcon"
      onDialogClose={handleClose}
      isCustomBackground={false}
      isborderDialogAction={true}
      otherDialogProps={{
        fullWidth: false,
      }}
      customDialogActions={
        <>
          <div className={classes.txtRight}>
            {/* @frontend : add condition for disable button (disabled class name) */}
            <Button className={classes.outlineBtn} autoFocus color="primary" onClick={handleViewChallenges}>
              View challenges
            </Button>
            <Button className={classes.primaryBtn} autoFocus color="primary" onClick={handleClose}>
              Resume Editing
            </Button>
          </div>
        </>
      }
    >
      <Grid container direction="row" justify="center" alignItems="center">
        {/* <Grid className={classes.editImg}> */}
        <Grid>
          <img src="/assets/svg/myLibrary/edit-page.svg" alt="Edit icon" />
        </Grid>
        <Grid>
          <Typography
            className={[
              classes.normalTxt,
              classes.txtCenter,
              // classes.marginLR,
            ].join(" ")}
          >
            If you wish to close the edit page then no action will be taken in
            this challenge. Are you sure you do not want to make any changes in
            the content?{" "}
          </Typography>
        </Grid>
      </Grid>
    </MyPATDialog>
  );
}

// @ts-ignore
export default withStyles(styles)(ForceSaveForChallengePopup);
